import React, {Fragment} from 'react';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {Drawer} from 'presentation/components/Drawer';
import {DistanceFilterContent} from '../DistanceFilterContent';
import {DistanceFilterProps} from './types';
import {translations} from 'presentation/translations-new';

import {useDistanceSliderStore} from '../../../DistanceSlider/store';

const {filter} = translations['pt-br'].commons;

export function DistanceFilter({
	distanceFilterAtMaxDistance,
	handleClearDistance,
	handleConfirmDistance,
	openDrawerState,
}: DistanceFilterProps) {
	const distanceSlider = useDistanceSliderStore(state => state.distanceSlider);

	return (
		<Fragment>
			<DistanceFilterContent
				distanceFilterAtMaxDistance={distanceFilterAtMaxDistance}
				openDrawerState={openDrawerState}
			/>
			<Drawer.Footer
				firstButtonDataTagId={AppointmentBookingEnum.LIMPOU_FILTRO_DISTANCIA}
				secondButtonDataTagId={AppointmentBookingEnum.APLICOU_FILTRO_DISTANCIA}
				firstButtonOnClick={handleClearDistance}
				secondButtonTitle={`${filter} ${distanceSlider}km`}
				secondButtonOnClick={handleConfirmDistance}
			/>
		</Fragment>
	);
}
